export default __webpack_public_path__ + "static/media/ReportIcon-Heart-MS.e2d59e5c.jpg";